<template>
  <div class="a-divider"></div>
</template>

<script setup>
</script>

<style lang="scss">
</style>
